export interface Identifiable {
  id: string
}
